export default "__VITE_ASSET__C$lg8ZCx__"